export default {
    data(){
        return {
            links: {
                journal: 'https://www.youtube.com/embed/Qo2xocF6zd4', // Журнал записей
                firstSetting: 'https://www.youtube.com/embed/Qo2xocF6zd4', // Первая настройка
                yaMetric: 'https://www.youtube.com/embed/YOQEprCJpKE', // Яндекс.метрика
                scenario: 'https://www.youtube.com/embed/Pa-xNPpC6As', // Сценарий начала записи
                addUsers: 'https://www.youtube.com/embed/6lDZhulUnKc', // Доп.аккаунты
                company: 'https://www.youtube.com/embed/r6FBMrzot2U', // Компании
            }
        }
    },
  methods: {
      getYotubeLink(linkName){
          return this.links[linkName];
      }
  }
};